import { Map } from 'immutable'
import {
  SET_PM_TERM_PROCESSING,
  SET_PM_TERM,
  SET_PM_TERM_ERROR,
} from './actions'

export const initialState = Map()
// const key = 'terms'

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_PM_TERM_PROCESSING:
      return state.setIn([Number(payload.id), 'processing'], payload.processing)
    case SET_PM_TERM:
      return state
        .setIn([payload.data.get('tid', 0)], payload.data)
        .setIn([payload.data.get('tid', 0), 'processing'], false)
    case SET_PM_TERM_ERROR:
      return state
        .setIn([payload.id], payload.error)
        .setIn([payload.id, 'processing'], false)
    default:
      return state
  }
}
